
import SweetScroll from "sweet-scroll";
class CheckValidate {
  constructor() {
    let inputElms = document.querySelectorAll('[data-check-input]');
    this.pushConfirmBtn();
    for(let i=0;i<inputElms.length;i++) {
      inputElms[i].addEventListener('blur', (e)=> {
        this.inputMsg(e, this.checkandReturnMsg(e));
      })
    }
  }

  inputMsg(e, msg) {
    let elm;
    if (e.path != null) {
      elm = e.path[3].childNodes[3].childNodes[3];
      if(elm == null) {
        elm = e.path[3].childNodes[3].childNodes[1].childNodes[3];
      }
    } else {
      elm = e.offsetParent.childNodes[3];
      if(elm == null) {
        elm = e.offsetParent.childNodes[1].childNodes[3];
      }
    }
    elm.innerText = msg;
  }

  checkandReturnMsg(e) {
    let value,name,checkItems,msg;

    let target = e.currentTarget;
    if(target == null) {
      value = e.value;
      name = e.name;
      checkItems = e.dataset.checkInput.split(",");
    } else {
      value = e.currentTarget.value;
      name = e.currentTarget.name;
      checkItems = e.currentTarget.dataset.checkInput.split(",");
    }
      msg = null;

    // 必須チェック
    if(checkItems.indexOf('required') >= 0){
      msg = this.isNull(value, name);
    }

    //　数値チェック
    if(checkItems.indexOf('number') >= 0 && msg == null) {
      msg = this.isNumber(value, name);
    }

    //　メールアドレスチェック
    if(checkItems.indexOf('mail') >= 0 && msg == null) {
      msg = this.isMail(value, name);
    }

    //　再入力チェック（メールアドレス）
    if(checkItems.indexOf('reenter') >= 0 && msg == null) {
      let jsMails = document.getElementsByClassName('js-mail')
      if(jsMails[0].value !== jsMails[1].value) {
        msg = name + 'が異なります。';
      }
    }
    return msg;
  }

  isNull(value, itemName) {
    if(value === null || value === "") {
      return itemName + 'を入力してください。'
    }
    return null;
  }

  isNumber(value, itemName) {
    if(!value.match(/^\d{3}-\d{4}-\d{4}$|^\d{11}$/)) {
      return itemName + 'は半角英数で入力してください。'
    }
    return null;
  }
  isMail(value, itemName) {
    if(!value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      return itemName + 'が相応しくありません。'
    }
    return null;
  }

  pushConfirmBtn() {
    let cfbElm = document.getElementById('SublitBtn');
    cfbElm.addEventListener('click', e => {
      let isInvalid　= false;
      e.preventDefault();
      let inputs = document.querySelectorAll('[data-check-input]');
      inputs.forEach(input => {
        let msg = this.checkandReturnMsg(input);
        if(msg != '' && msg != null) {
          this.inputMsg(input, msg);
          isInvalid = true;
        };
      });
      if (!isInvalid) {
        document.querySelectorAll('[data-radio-none="none"]').forEach(elm => {
          elm.parentNode.removeChild(elm);
        })
        document.contactForm.submit();
      }
    });
  }

}


class DrawerMenu {
  constructor() {
    this.drawerMenuElm = document.getElementById('DrawerMenu');
    this.GnavElm = document.getElementById('Gnav');
    this.DrawerListElm = document.getElementById('DrawerList');
    this.drawerIconLeftElm = document.getElementById('drawerIconLeft');
    this.drawerIconRightElm = document.getElementById('drawerIconRight');
    this.gnavItemElms = document.getElementsByClassName('gnav-item');

    this.drawerMenuElm.addEventListener('click', (event) => {
      event.preventDefault();
      if(this.GnavElm.classList.contains('isOpen')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    for(let i = 0; i<this.gnavItemElms.length;i++) {
      this.gnavItemElms[i].addEventListener('click', ()=> {this.closeMenu()});
    }

  }

  openMenu() {
    this.GnavElm.classList.add('isOpen');
    this.DrawerListElm.style.height = "auto";

    this.drawerIconLeftElm.style.transform = 'rotate(-40deg)';
    this.drawerIconRightElm.style.transform = 'rotate(40deg)';

    setTimeout(()=>{
      this.GnavElm.style.height = '440px';
    },100);

    setTimeout(()=>{
      for(let i = 0; i < this.gnavItemElms.length; i++) {
        this.gnavItemElms[i].style.opacity = 1;
        this.gnavItemElms[i].style.top = 0;
      }
    },300)
  }

  closeMenu() {
    if(!isTouchDevice) {
      return;
    }
    this.GnavElm.classList.remove('isOpen');

    this.drawerIconLeftElm.style.transform = 'rotate(40deg)';
    this.drawerIconRightElm.style.transform = 'rotate(-40deg)';

    setTimeout(()=>{
      this.GnavElm.style.height = '0px';
    },100);

    setTimeout(()=>{
      for(let i = 0; i < this.gnavItemElms.length; i++) {
        this.gnavItemElms[i].style.opacity = 0;
        this.gnavItemElms[i].style.top = '-30px';
        this.DrawerListElm.style.height = "0px";
      }
    },100)
  }
}

    let ua = navigator.userAgent.toLowerCase();
    //
    let isTouchDevice = (ua.indexOf('iphone') > -1) || // iPhone
                         ua.indexOf('ipad') > -1 || // iPad
                         (ua.indexOf('android') > -1) && (ua.indexOf('mobile') > -1) || // Android
                         (ua.indexOf('android') > -1) && (ua.indexOf('mobile') == -1); // Android Tablet

                         if (isTouchDevice) {
                           document.write('<link rel="stylesheet" type="text/css" href="./assets/css/touchDevice.css">');

                          //  new DrawerMenu();
                         }


class LessonProduction {
  constructor() {
    let headerMsgElm = document.getElementsByClassName('keyVisual_header')[0];
    let subHeaderElm = document.getElementsByClassName('keyVisual_subHeader')[0];

    headerMsgElm.style.left = '0';
    let moveMsgElms = document.querySelectorAll('[data-move-msg]');
    for(let i = 0; i<moveMsgElms.length;i++) {
      moveMsgElms[i].style.transform = 'rotateY(0deg)';
    }
    setTimeout(function() {
      subHeaderElm.style.opacity = 1;
    },1200)

  }
}

/*
 * トップページ演出クラス
 */
class TopProduction {
  constructor() {
    // トップ読込みデータ
    this.loadData = [
      {id:"logo", src:"./assets/img/logo.png"},
      {id:"logo", src:"./assets/img/logo@2x.png"},
      {id: "awesome", src:"./assets/css/font-awesome.min.css"},
      {id: "awesomeFont", src:"./assets/fonts/fontawesome-webfont.woff2"},
      // {id: "TouchDeviceCSS", src:"./assets/css/touchdevice.css"},
      {id:"img1", src:"./assets/img/lessonImage.jpg"},
      {id:"img2", src:"./assets/img/logo_head.png"},
      {id:"img3", src:"./assets/img/logo_midori.gif"},
      {id:"img4", src:"./assets/img/logo_orage.jpg"},
      {id:"img5", src:"./assets/img/logo_spy.png"},
      {id:"img6", src:"./assets/img/mainImage5.jpg"},
      {id:"img7", src:"./assets/img/profileImage.jpg"},
      {id:"img8", src:"./assets/img/movieImage.jpg"},
      {id:"img9", src:"./assets/img/header_logo.png"}
    ];
    this.init();
  }

  init() {
    let queue = new createjs.LoadQueue(false);
    queue.on("fileload", this.handleFileComplete);
    queue.on("complete", this.handleComplete);
    queue.loadManifest(this.loadData);
  }

  /* １ファイルを読み込んだ後の処理 */
  handleFileComplete(event) {
    // 読み込んだファイルのIDによって処理を分ける
    switch(event.item.id) {
      case 'logo':
        setTimeout(function() {
          document.getElementById('MainVisualLogo').style.opacity = '1';
          }, 100);
          break;
      case 'awesome':
        document.getElementById('AwesomeStyle').href = event.item.src;
        break;
    }
  }

  /* 全ファイルを読み込んだ後の処理 */
  handleComplete() {
    setTimeout(function() {
      document.getElementById('MainText').style.transform = 'translate(0, 38vh)';
      document.getElementById('MainVisualMessage').style.opacity = '1';
      document.getElementById('MainVisualApplyBtn').style.opacity = '1';
    }, 2200);
    setTimeout(function() {
      document.getElementById('Header').style.top = '0';
    }, 3000);
    setTimeout(function() {
      document.getElementById('MainVisual').style.opacity = '1';
      document.getElementById('ScrollArrowLink').style.opacity = '.6';
    }, 3000);
  }
}

/*
 * トップページのスクロールアクションクラス
 */
export default class ScrollActions {
  constructor(isTouchDevice) {
    this.isTouchDevice = isTouchDevice;
    this.s_h = window.pageYOffset;
    this.w_h = window.innerHeight;
    this.p = this.s_h / this.s_w;
    this.h = document.getElementById('MainTextArea').clientHeight;
    this.v = document.getElementById("video");
    this.v.pause();
    this.movieTop = document.getElementById('Movie').getBoundingClientRect().top;

    // 設定値
    this.options = {
      mainTextRate : 1/3,        // メインテキスト消えかかる位置
      conceptRate : 0.98,        // コンセプトテキストの表示し始める位置
      maskBlackOpacity : 0.65    // ブラックマスクの透明度
    }
  }

  /* メインビジュアルのポジション変更 */
  changeMainImagePosition() {
    this.s_h = window.pageYOffset;
    this.w_h = window.innerHeight;
    this.h = document.getElementById('MainTextArea').clientHeight;
    let elm = document.getElementById('MainVisual');

    if(!this.isTouchDevice) {
      if (this.s_h >= this.h - this.w_h) {
        elm.style.top = (this.w_h/10)*9 + 'px';
        elm.style.position = 'absolute';
        // elm.style.transform = 'translateY(' +  0 + 'px)';
      } else {
        // elm.style.top = '0';

        // elm.style.transform = 'translateY(' +  this.s_h + 'px)';
        elm.style.position = 'fixed';
        elm.style.top = '0px';
      }
    }
  }

  /* トップテキストの表示・非表示変更 */
  displayText() {
    this.p = this.s_h / this.w_h;

    let opacityValueMainText = (1 - this.p / this.options.mainTextRate);
    let opacityValueConceptMessage =  this.p / this.options.conceptRate;
    document.getElementById('MainText').style.opacity = opacityValueMainText;
    document.getElementById('ConceptMessage').style.opacity = opacityValueConceptMessage;

  }

  /* スクロール矢印の表示・非表示変更 */
  dispScrollArrow() {
    document.getElementById('ScrollArrow').style.opacity = 1 - (this.p*3);
  }

  /* マスクの透明度調整 */
  opacityBgBlack() {
    let opacityValue = (this.p > this.options.maskBlackOpacity)? this.options.maskBlackOpacity : this.p;
    let elm = document.getElementById('BlackMsk');

    if (this.s_h >= this.h) {
      elm.style.display = 'none';
      elm.style.opacity = this.options.maskBlackOpacity;
    } else {
      elm.style.opacity = opacityValue;
      elm.style.display = 'block';
    }
  }

  /* 申込みボタンの背景変更 */
  changeApplyBtnColor(isTouchDevice) {
    let elm = document.getElementById('applyBtnLink');
    // if(isTouchDevice) {
    //   return;
    // }
    if (this.s_h >= (this.h - this.w_h) * 1.05) {
       elm.style.backgroundColor = "#EE4F4A";
    } else {
       elm.style.backgroundColor = "#313131";
    }
  }

  /* ムービーオート再生 */
  startMovie() {
    if(this.movieTop - 300 < this.s_h) {
      this.v.play();
    } else {
      this.v.pause();
    }
  }
}

/*
 * moreボタン制御クラス
 */
class PushBtnTop {
  constructor() {
    this.profileMoreElm = document.getElementById('ProfileMore');
    this.profileMoreElmHeight = this.profileMoreElm.offsetHeight + 'px';
    this.profileMoreElm.style.height = '0px'

    this.movieMoreElm = document.getElementById('MovieMore');
    this.movieMoreElmHeight = this.movieMoreElm.offsetHeight + 'px';
    this.movieMoreElm.style.height = '0px'
    this.init();
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
    let sweetScroll = new SweetScroll({duration: 2000});
    }, false);
  }

  /* moreボタン処理（プロフィール） */
  pushProfileMoreBtn() {
    let isOpenClassName = 'isOpenProfileMore';

    let profileMoreTextElm = document.getElementById('ProfileMoreText');
    let profilePlusMarkElm = document.getElementById('ProfilePlusMark');
    let profilePlusElm = document.getElementById('ProfilePlus');
    let profileMoreBtn = document.getElementById('ProfileMoreBtn')

    let isOpen = false;
    document.getElementById('ProfileMoreBtn').addEventListener('click', (event) => {
      event.preventDefault();
      this.init();
      isOpen = this.profileMoreElm.classList.contains(isOpenClassName);

      if(isOpen) {
        profileMoreTextElm.style.opacity = 1;
        profilePlusElm.style.bottom = '30px';
        profilePlusMarkElm.style.transform = 'rotate(0deg)';
        this.profileMoreElm.style.height = '0px';
        this.profileMoreElm.classList.remove(isOpenClassName);
        profileMoreBtn.setAttribute('data-scroll','-=200');
      } else {

        profileMoreTextElm.style.opacity = 0;
        profilePlusElm.style.bottom = '-70px';
        profilePlusMarkElm.style.transform = 'rotate(45deg)';
        this.profileMoreElm.style.height = this.profileMoreElmHeight;
        this.profileMoreElm.classList.add(isOpenClassName);

        profileMoreBtn.setAttribute('data-scroll','+=200');
      }
    })
  }

  /* moreボタン処理（ムービー） */
  pushMovieMoreBtn() {
    let isOpenClassName = 'isOpenMovieMore';

    let movieMoreTextElm = document.getElementById('MovieMoreText');
    let moviePlusMarkElm = document.getElementById('MoviePlusMark');
    let moviePlusElm = document.getElementById('MoviePlus');
    let movieMoreBtn = document.getElementById('MovieMoreBtn')

    let isOpen = false;
    document.getElementById('MovieMoreBtn').addEventListener('click', (event) => {
      event.preventDefault();
      isOpen = this.movieMoreElm.classList.contains(isOpenClassName);

      if(isOpen) {
        movieMoreTextElm.style.opacity = 1;
        moviePlusElm.style.bottom = '30px';
        moviePlusMarkElm.style.transform = 'rotate(0deg)';
        this.movieMoreElm.style.height = '0px';
        this.movieMoreElm.classList.remove(isOpenClassName);
        movieMoreBtn.setAttribute('data-scroll','-=200');
      } else {

        movieMoreTextElm.style.opacity = 0;
        moviePlusElm.style.bottom = '-70px';
        moviePlusMarkElm.style.transform = 'rotate(45deg)';
        this.movieMoreElm.style.height = this.movieMoreElmHeight;
        this.movieMoreElm.classList.add(isOpenClassName);

        movieMoreBtn.setAttribute('data-scroll','+=200');
      }
    })
  }
}

/*
 * ウィンドウ高さによる表示位置調整処理クラス
 */
class AdjustByDisplayHeight {
  constructor() {
    this.w_h = window.innerHeight;
    this.LessonBoxInnerElm = document.getElementById('LessonBoxInner');
  }

    /* レッスンメニュー表示位置調整 */
  adjustLesson() {
    this.w_h = window.innerHeight;
    if (this.w_h > 850) {
      this.LessonBoxInnerElm.style.bottom = 15 + '%'
    } else {
      let p = this.w_h / 850 * 0.5;
      this.LessonBoxInnerElm.style.bottom = 15 * p + '%'
    }
  }
}

/*
 * 申し込みフォームの料金表切り替えクラス
 */
class ChangePriceMenu {
  constructor() {
    this.elms = document.querySelectorAll('[data-lesson-menu]');
    for (let i = 0; i < this.elms.length; i++) {
      let elm = this.elms[i];
      elm.addEventListener('change', () => {this.changePriceMenu(elm)})
    }
  }

  changePriceMenu(elm) {
    let type = elm.getAttribute('data-lesson-menu');

    // レッスン料金表の切り替え
    let priceElms = document.querySelectorAll('[data-lesson-price]');
    for (let i = 0; i < priceElms.length; i++) {
      let priceElm = priceElms[i];
      if (type === priceElm.getAttribute('data-lesson-price')) {
        priceElm.style.display = "block";
        priceElm.setAttribute('data-radio-none', 'block');
      } else {
        priceElm.style.display = "none";
        priceElm.setAttribute('data-radio-none', 'none');
      }
    }

    let hopeDayElms = document.querySelectorAll('[data-lesson-day]');
    for (let i = 0; i < hopeDayElms.length; i++) {
      let hopeDayElm = hopeDayElms[i];
      let dataValue = hopeDayElm.getAttribute('data-lesson-day');

      if (type === 'contact') {
        if (type === dataValue) {
          hopeDayElm.style.display = "block";
        } else {
          hopeDayElm.style.display = "none";
        }
      } else {
        if (dataValue === 'contact') {
          hopeDayElm.style.display = "none";
        } else {
          hopeDayElm.style.display = "block";
        }
      }
    }
  }
}

class DisplayCalendar {
  constructor() {
    this.calendarBtnElms = document.querySelectorAll('[data-calendar-btn]');
    this.calendarElm = document.getElementById('Calendar');
    this.calendarMskElm = document.getElementById('CalendarMsk');
    this.closeCalendarBtnElm = document.getElementById('CloseCalendarBtn');
    this.addEvent();
  }

  addEvent() {
    for (let i = 0; i < this.calendarBtnElms.length; i++) {
      this.calendarBtnElms[i].addEventListener('click', (event) => {
        event.preventDefault();
        this.controll();
      });
    }
    this.calendarMskElm.addEventListener('click', () => {this.controll()});
    this.closeCalendarBtnElm.addEventListener('click', () => {this.controll()});
  }

  controll() {
    let calendarBtnElm = this.calendarBtnElms[0];
    let calendarState = calendarBtnElm.getAttribute('data-calendar-btn');

    if(calendarState === 'on') {
      this.hideCalendar();
    } else {
      // offの場合
      this.displayCalendar();
    }
  }

  displayCalendar() {
    this.calendarElm.style.display = 'block';
    setTimeout(() => {this.calendarElm.style.opacity = '1';}, 100);


    for (let i = 0; i < this.calendarBtnElms.length; i++) {
      this.calendarBtnElms[i].setAttribute('data-calendar-btn', 'on')
    }
  }

  hideCalendar() {
    this.calendarElm.style.opacity = 0;
    setTimeout(() => {
      this.calendarElm.style.display = 'none';
    }, 800);

    for (let i = 0; i < this.calendarBtnElms.length; i++) {
      this.calendarBtnElms[i].setAttribute('data-calendar-btn', 'off')
    }
  }
}

new DisplayCalendar();

class DisplayAndMoveBySeason {
  constructor() {
    this.month = (new Date()).getMonth();
    this.elms = document.querySelectorAll('[data-lesson-apply]');
    this.options = {
      winterSeason: [0,1,2,3,4,10,11],
      summerSeason: [4,5,6,7,8,9,10],
      winterSeasonLink: './lessonWinter.html',
      summerSeasonLink: './lessonSummer.html'
    }
    this.isWinter = true;
    this.init();
  }

  init() {
    if (-1 === this.options.winterSeason.indexOf(this.month)) {
      this.isWinter = false;
    };
  }

  moveDisplayByApplyBtn() {
    for(let i = 0; i < this.elms.length; i++) {
      this.elms[i].addEventListener('click', (event) => {
        event.preventDefault();
        let url;
        if(this.isWinter) {
          url = this.options.winterSeasonLink
        } else {
          url = this.options.summerSeasonLink
        }
        location.href = url;
      });
    }
  }

  displayControllApplyFormSummer() {
    // サマーシーズンのフォーム表示切り替え
    if (-1 === this.options.summerSeason.indexOf(this.month)) {
      document.getElementById('LessonFormSummer').style.display = 'none';
    } else {
      document.getElementById('LessonFormSummerMessage').style.display = 'none';
    };
  }
  displayControllApplyFormWinter() {
    // ウィンターシーズンのフォーム表示切り替え
    if (-1 === this.options.winterSeason.indexOf(this.month)) {
      document.getElementById('LessonFormWinter').style.display = 'none';
    } else {
      document.getElementById('LessonFormWinterMessage').style.display = 'none';
    };
  }
}

let displayAndMoveBySeason = new DisplayAndMoveBySeason();
displayAndMoveBySeason.moveDisplayByApplyBtn();
if(document.getElementById('LessonFormSummer') !== null) {
  displayAndMoveBySeason.displayControllApplyFormSummer();
}
if(document.getElementById('LessonFormWinter') !== null) {
  displayAndMoveBySeason.displayControllApplyFormWinter();
  new CheckValidate();
}

if (document.getElementById('WinterLesson') != null) {
  new ChangePriceMenu();
  new LessonProduction();
  new CheckValidate();
}

if (document.getElementById('SummerLesson') != null) {
  new ChangePriceMenu();
  new LessonProduction();
  new CheckValidate();
}

// トップページのみで実施する処理
if (document.getElementById('Top') != null ) {
  new TopProduction();

  let adjustByDisplayHeight = new AdjustByDisplayHeight();
  window.addEventListener('resize', () => {
    adjustByDisplayHeight.adjustLesson();
  })


  let pushBtnTop = new PushBtnTop();
  pushBtnTop.pushProfileMoreBtn();
  pushBtnTop.pushMovieMoreBtn();

  let scrollActions = new ScrollActions(isTouchDevice);
  // document.getElementById('Wrap').addEventListener('scroll', () => {
  window.addEventListener('scroll', () => {
    scrollActions.changeMainImagePosition(isTouchDevice);
    scrollActions.displayText();
    scrollActions.opacityBgBlack();
    scrollActions.changeApplyBtnColor(isTouchDevice);
    scrollActions.dispScrollArrow();
    scrollActions.startMovie();
  });
  window.addEventListener('resize', () => {
    scrollActions.changeMainImagePosition(isTouchDevice);
    scrollActions.displayText();
    scrollActions.opacityBgBlack();
    scrollActions.changeApplyBtnColor(isTouchDevice);
    scrollActions.dispScrollArrow();
    scrollActions.startMovie();
  });
  window.addEventListener('touchmove', () => {
    scrollActions.changeMainImagePosition(isTouchDevice);
    scrollActions.displayText();
    scrollActions.opacityBgBlack();
    scrollActions.changeApplyBtnColor(isTouchDevice);
    scrollActions.dispScrollArrow();
    scrollActions.startMovie();
  });

  window.addEventListener('load', () => {
    adjustByDisplayHeight.adjustLesson();
  });
}

new DrawerMenu();



// WEBPACK FOOTER //
// ./src/assets/js/app.js